<div
  class="flex flex-col flex-nowrap items-start justify-start w-full h-fit min-h-[255px] pl-[34px] pr-[34px] pt-[34px] pb-[34px] gap-[16px] bg-white rounded-lg border border-[#C6C6C6] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]"
>
  <div class="flex flex-col flex-nowrap items-start justify-start w-fit h-fit">
    <span class="text-[#161C23] text-xl font-semibold leading-7 tracking-normal text-left w-[222px]"
      >{{ title1() }}<br />{{ title2() }}</span
    >
  </div>
  <div class="flex flex-col flex-nowrap items-start justify-start w-full h-fit pr-[11px]">
    <span
      class="text-[#474747] text-sm font-normal leading-[22.75px] tracking-normal text-left w-full h-fit"
      >{{ description() }}</span
    >
  </div>
</div>
